module.exports = __webpack_public_path__ + "img/ko_arima7.8ed66729.jpg";